var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.783,
    height: 18.889,
    viewBox: "0 0 16.783 18.889",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#53b5e0;stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-167.962 -175.822)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 4.773,
    cy: 4.773,
    r: 4.773,
    transform: "translate(171.58 176.322)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M184.112,197.827a7.975,7.975,0,0,0-15.517,0Z",
    transform: "translate(0 -3.616)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff);
export default __webpack_public_path__ + "static/media/staff.70a579b552ecb25b431707c65b4ecea1.svg";
export { ForwardRef as ReactComponent };